import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

import { DeclarationDocumentsEnum } from '@e-origin/shared';

export const customerImportGuaranteesSchema = z.object({
  documents: z.object({
    [DeclarationDocumentsEnum.GUARANTEE_DOCUMENTS]: z.array(
      z.object({
        header: z.boolean().optional().nullable(),
        reference: z.object({
          accessCode: z.string().optional().nullable(),
          amountTobeCovered: z.number().optional().nullable(),
          currencyCode: z.string().optional().nullable(),
          customsOfficeGuarantee: z.object({
            referenceNumber: z.string().optional().nullable(),
          }),
          dateOfValidity: z.string().optional().nullable(),
          grn: z.string().optional().nullable(),
          otherGuaranteeReference: z.string().optional().nullable(),
        }),
        type: z.string().optional().nullable(),
      }),
    ),
  }),
  personProvidingGuarantee: z.object({
    identificationNumber: z.string().optional().nullable(),
  }),
});
export type CustomerViewImportGuaranteesFormValues = z.infer<typeof customerImportGuaranteesSchema>;

export const useCustomerViewImportGuaranteesFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => ({
    documents: {
      [DeclarationDocumentsEnum.GUARANTEE_DOCUMENTS]: (cd?.documents?.guaranteeDocuments || []).map((guaranteeDocument) => ({
        header: guaranteeDocument.header || '',
        reference: {
          accessCode: guaranteeDocument.reference?.accessCode || '',
          amountTobeCovered: guaranteeDocument.reference?.amountTobeCovered || 0,
          currencyCode: guaranteeDocument.reference?.currencyCode || '',
          customsOfficeGuarantee: {
            referenceNumber: guaranteeDocument.reference?.customsOfficeGuarantee?.referenceNumber || '',
          },
          dateOfValidity: guaranteeDocument.reference?.dateOfValidity || '',
          grn: guaranteeDocument.reference?.grn || '',
          otherGuaranteeReference: guaranteeDocument.reference?.otherGuaranteeReference || '',
        },
        type: guaranteeDocument.type || '',
      })),
    },
    personProvidingGuarantee: {
      identificationNumber: cd?.personProvidingGuarantee?.identificationNumber || '',
    },
  });

  const form = useForm<CustomerViewImportGuaranteesFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerImportGuaranteesSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
